import { useForm, zodResolver } from '@mantine/form';

import { useUpdateDeclarationDataLrn, useUpdatePartialDeclaration } from '@hooks/declaration';
import { isHighValueDeclaration } from '@utils';
import { DeclarationViewCustomsTreatmentFormValues, declarationViewCustomsTreatmentSchema } from './validateDeclarationViewCustomsTreatmentForm';

export const useDeclarationViewCustomsTreatmentForm = ({ declaration }) => {
  const saveDeclarationDataLRNMutation = useUpdateDeclarationDataLrn();
  const savePartialDataToDeclarationMutation = useUpdatePartialDeclaration();

  const isExport = declaration?.generalInfo?.isExport;

  const buildFormValues = (d) => ({
    messageInfo: {
      methodOfPayment: d?.messageInfo?.methodOfPayment,
      deferredPayment: d?.messageInfo?.deferredPayment,
      deferredPaymentVAT: d?.messageInfo?.deferredPaymentVAT,
      methodOfPaymentVAT: d?.messageInfo?.methodOfPaymentVAT,
    },
    valuationInformationTaxes: {
      globalChargesimport: {
        CustomsCharges: {
          charges: d?.valuationInformationTaxes?.globalChargesimport?.CustomsCharges?.charges,
          currency: d?.valuationInformationTaxes?.globalChargesimport?.CustomsCharges?.currency,
        },
        VATcharges: {
          charges: d?.valuationInformationTaxes?.globalChargesimport?.VATcharges?.charges,
          currency: d?.valuationInformationTaxes?.globalChargesimport?.VATcharges?.currency,
        },
      },
      chargesimport: {
        CustomsCharges: {
          charges: d?.valuationInformationTaxes?.chargesimport?.CustomsCharges?.charges,
          currency: d?.valuationInformationTaxes?.chargesimport?.CustomsCharges?.currency,
        },
        VATcharges: {
          charges: d?.valuationInformationTaxes?.chargesimport?.VATcharges?.charges,
          currency: d?.valuationInformationTaxes?.chargesimport?.VATcharges?.currency,
        },
      },
      valuationMethod: d?.valuationInformationTaxes?.valuationMethod,
      valuationAdjustment: d?.valuationInformationTaxes?.valuationAdjustment || {},
    },
    consignment: {
      transportCost: {
        amount: d?.consignment?.transportCost?.amount,
        currencyCode: d?.consignment?.transportCost?.currencyCode,
      },
    },
  });

  const form = useForm<DeclarationViewCustomsTreatmentFormValues>({
    initialValues: buildFormValues(declaration),
    validate: zodResolver(declarationViewCustomsTreatmentSchema),
    validateInputOnBlur: true,
  });

  const onSubmit = async (values) => {
    if (isHighValueDeclaration(declaration.generalInfo.group)) {
      await saveDeclarationDataLRNMutation.mutateAsync({
        lrn: declaration.messageInfo.LRN,
        sequence: declaration.goodShipmentGlobal.sequence,
        partialDeclaration: values,
      });
    } else {
      await savePartialDataToDeclarationMutation.mutateAsync({ id: declaration._id, partialDeclaration: values });
    }
  };

  return {
    isExport,
    form,
    isSaving: saveDeclarationDataLRNMutation.isPending || savePartialDataToDeclarationMutation.isPending,
    onSubmit,
    buildFormValues,
  };
};
